import { isGraphAPIEnabled } from '@wix/wix-vod-shared/dist/src/common/utils/experiments';
import { createPublicPurchaseService } from '@wix/wix-vod-api/dist/src/public/purchase';
export var publicApi = {};
export function initPublicServices(instance, baseUrl) {
    var isV3 = isGraphAPIEnabled();
    publicApi.purchase = createPublicPurchaseService(isV3, instance, baseUrl);
}
